module.exports = __webpack_public_path__ + "media/images/menu/text-d8ad8f1fc8dbe9afd854fe33d6e3def3.svg";